import { CLAN_QUESTS_LOAD_ERROR, CLAN_QUESTS_LOAD_REQUEST, CLAN_QUESTS_LOAD_SUCCESS } from 'state/actions/clanQuests'

export const initialState = {
    errorMessage: null,
    isError: false,
    loading: false,
    loaded: false,
    lastRequestTimestamp: null,
    disabled: false,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case CLAN_QUESTS_LOAD_REQUEST: {
        return {
            ...state,
            loading: true,
            errorMessage: null,
            lastRequestTimestamp: Date.now(),
        }
    }
    case CLAN_QUESTS_LOAD_SUCCESS: {
        return {
            ...state,
            disabled: false,
            ...action.payload,
            loading: false,
            loaded: true,
            isError: false,
            lastRequestTimestamp: Date.now(),
        }
    }
    case CLAN_QUESTS_LOAD_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: false,
            isError: true,
            errorMessage: action.payload.errorMessage || action.payload.statusCode,
            lastRequestTimestamp: Date.now(),
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/clanQuests.js